export class Constants {
	static equipmentFadeDurationMS: number = 600;
}